import { instantMeiliSearch } from "@meilisearch/instant-meilisearch";

const search = instantsearch({
    indexName: "still_images",
    routing: true,
    searchClient: instantMeiliSearch(
        "https://mpla-search.pazpar2.com/",
        "0401d339-02f4-4492-9d3a-13128924d1da",
        {
            finitePagination: true,
        }
    ),
});

search.addWidgets([
    instantsearch.widgets.searchBox({
        container: "#searchbox",
    }),
    instantsearch.widgets.clearRefinements({
        container: "#clear-refinements",
    }),
    instantsearch.widgets.refinementList({
        container: "#subject-list",
        attribute: "subject_list",
    }),
    instantsearch.widgets.refinementList({
        container: "#street-name-list",
        attribute: "places.place_id.street_name",
    }),
    instantsearch.widgets.refinementList({
        container: "#street-number-list",
        attribute: "places.place_id.street_number",
    }),
    instantsearch.widgets.refinementList({
        container: "#historic-names",
        attribute: "places.place_id.historic_names",
    }),
    instantsearch.widgets.refinementList({
        container: "#historic-uses",
        attribute: "places.place_id.historic_uses",
    }),
    instantsearch.widgets.configure({
        hitsPerPage: 12,
        snippetEllipsisText: "...",
        attributesToSnippet: ["description:50"],
    }),
    instantsearch.widgets.hits({
    container: "#hits",
    templates: {
        item: `
            <div class="col">
              <div class="zoom-effect position-relative pb-3" style="max-width: 512px;">
                <div class="zoom-effect-wrapper">
                  <div class="zoom-effect-img">
                    <a href="/still_images/{{ id }}">
                       <img id="poster-img"
                           src="/assets/mpla-images/{{scan_code_identifier_front}}.png"
                           class="rounded-5 figure-img d-flex justify-content-center" />
                    </a>
                  </div>
                </div>
                <div class="pt-1 mt-lg-2">
                  <div class="h4 mb-2 text-truncate">
                    <a class="stretched-link"
                        href="/still_images/{{ id }}">
                        {{#helpers.highlight}}{ "attribute": "title" }{{/helpers.highlight}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            `,
        },
    }),
    instantsearch.widgets.pagination({
        container: "#pagination",
    })
]);

search.start();
